import styles from "../Profile.module.css";

// items: [{ key, period, title, body }]
const Timeline = ({ items }) => (
  <ol className={styles.timeline}>
    {items.map((item) => (
      <li key={item.key} className={styles.timelineItem}>
        {item.period && (
          <div className={styles.timelinePeriod}>{item.period}</div>
        )}
        <div className={styles.timelineTitle}>{item.title}</div>
        {item.body && <div className={styles.timelineBody}>{item.body}</div>}
      </li>
    ))}
  </ol>
);

export default Timeline;
